import React, { createContext, useContext, useState } from 'react';
import type { IProyecto } from '../../modelos/Proyectos/entidades/IProyecto';
import { estadoInicialProyecto } from './interfaces';

interface ProyectoContextType {
    proyecto: IProyecto;
    setProyecto: React.Dispatch<React.SetStateAction<IProyecto>>;
}

export const ProyectoContext = createContext<ProyectoContextType | undefined>(undefined);

interface ProyectoProviderProps {
    children: React.ReactNode;
}

export const ProyectoProvider = ({ children }: ProyectoProviderProps) => {
    const [proyecto, setProyecto] = useState<IProyecto>(estadoInicialProyecto);

    return (
        <ProyectoContext.Provider value={{ proyecto, setProyecto }}>
            {children}
        </ProyectoContext.Provider>
    );
};

export const useProyecto = () => {
    const context = useContext(ProyectoContext);
    if (!context) {
        throw new Error('useProyecto debe usarse dentro de ProyectoProvider');
    }
    return context;
};